import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { Link } from 'react-router-dom';

//import axios from 'axios';
import axios_api from '../Api';
import { API_URL, AUTH_TOKEN } from '../Context';

import { STATUSES, GetTaskStatus, GetStatusTableClass, GetStatusTextClass, GetStatusIcon } from './Task';



export default function TasksList ({selectedYear}){

  const[tasks, setTasks] = useState([]);
  const[statusFilter, setStatusFilter] = useState("ALL");
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);


  React.useEffect(() => {

    let taskList = axios_api.get(api_url + '/expert_tasks/', {
      headers: {"Authorization": token},
      //params: {"year": selectedYear}
    });

    taskList.then(
      (result) => {
        //console.log(result);
        setTasks(result.data);
      },
      (error) => {
        console.log(error)
      }
    );

  }, []);

  // Фильтрация задач по статусу
  const filteredTasks = statusFilter === "ALL" ? tasks : tasks.filter(task => task.status === statusFilter);


  let taskCards = [];
  for (let i in filteredTasks) {
    let cardClassName = GetStatusTableClass(filteredTasks[i].status)
    let textClassName = GetStatusTextClass(filteredTasks[i].status)

    taskCards.push(
      <Link 
        key={i} 
        to={`/task/${filteredTasks[i].id}`} 
        style={{textDecoration: 'none', color: 'inherit'}}
      >
        <div 
          className={`card ${cardClassName} bg-opacity-10 shadow-sm`} 
          style={{
            marginBottom: '15px', 
            minHeight: '80px',
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '';
          }}
        >
          <div className="card-body d-flex align-items-center">
            <div className="me-3 d-flex align-items-center">
              {GetStatusIcon(filteredTasks[i].status)}
            </div>
            <div className="row align-items-center flex-grow-1">
              <div className="col-md-8">
                <h6 className="card-title mb-0">
                  {filteredTasks[i].form.replace(/#.*#/g, "")}
                </h6>
              </div>
              <div className="col-md-2">
                <span className={textClassName}>
                  {GetTaskStatus(filteredTasks[i].status)}
                </span>
              </div>
              <div className="col-md-2 text-end">
                <small className="text-muted">
                  Дата предоставления: <strong>{filteredTasks[i].deadline_date}</strong>
                </small>
              </div>
            </div>
          </div>
        </div>
      </Link>
    ); 
  }

  // Список статусов для фильтра
  const statusOptions = [
    { value: "ALL", label: "Все статусы" },
    ...Object.entries(STATUSES).map(([key, value]) => ({
      value: key,
      label: value
    }))
  ];

  return (
    <>
      <div className="row">
        <h3 className="m-3">Задания для проверки</h3>
      </div>
      <div className="row me-5">
        <div className="col-11">
          <div className="d-flex gap-3 m-3 mb-4 align-items-end">
            <label htmlFor="statusFilter" className="form-label fw-semibold">Cтатус:</label>
            <select 
              id="statusFilter"
              className="form-select" 
              value={statusFilter} 
              onChange={(e) => setStatusFilter(e.target.value)}
              style={{maxWidth: '300px'}}
            >
              {statusOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="m-3">
            {taskCards}
          </div>
        </div>
      </div>
    </>
  )
}